export default {
	state: {
		perfilInvestimento: {}
	},
	getters: {
		"perfilInvestimento": state => state.perfilInvestimento
	},
	mutations: {
		setPerfilInvestimento(state, payload) {
			state.perfilInvestimento = payload
		}
	},
	actions: {
		atualizarEstadoPerfilInvestimento({ commit }, payload) {
			commit('setPerfilInvestimento', payload)
		}
	}
};